/**
 * Action for wordpress/account module
 */
import wpAPI from '@/api/wordpress'
import {errorHandler} from '@/helpers'
import router from '@/router'
import types from './types'

const actions = {
  /**
   * ログイン処理
   * WP REST APIへアクセスするためのJWTを取得
   *
   */
  async [types.LOGIN] ({ dispatch, commit, getters, rootGetters }) {
    return wpAPI.getToken({
      username: getters.username,
      password: getters.password
    }).then(async res => {
      commit(types.LOGIN, {...res.data})
      let error = await dispatch(types.GET_ID)
      if (error) return error
      return null
    }).catch(errorHandler)
  },

  /**
   * ログアウト処理
   */
  [types.LOGOUT] ({ dispatch, commit, getters, rootGetters }) {
    commit(types.LOGOUT)
    router.push('/')
  },

  /**
   * ログイン後にユーザーリストを問い合わせ、
   * ログインユーザーのユーザーIDを取得する
   */
  async [types.GET_ID] ({ dispatch, commit, getters, rootGetters }) {
    return wpAPI.getUsers().then(async res => {
      const user = res.data.find(user => getters.username === user.name)
      commit(types.GET_ID, {id: user.id, avatar_urls: user.avatar_urls})
      return null
    }).catch(errorHandler)
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/store/modules/wordpress/account/actions.js